import { render } from "./Nephrology.vue?vue&type=template&id=969cb3e6"
import script from "./Nephrology.vue?vue&type=script&lang=ts"
export * from "./Nephrology.vue?vue&type=script&lang=ts"
script.render = render

export default script